export class BancoModel {

    public codBanco: number;
    public desBanco: string;
    public desBancoModel = this.codBanco.toString().concat(' - ').concat(this.desBanco);
}



// WEBPACK FOOTER //
// ./src/app/shared/model/banco.model.ts